import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'documents',
    initialState: {documents: [], document_single: false, message: false},
    reducers:{
        getDocuments: (state,action)=>{
            state.documents = action.payload
        },
        getOneDocument: (state,action)=>{
            state.document_single = action.payload
        },
        saveDocument: (state,action)=>{
            state.documents.unshift(action.payload)
            state.message = true
        },
        editDocument: (state,action)=>{
            state.documents = state.documents.filter(item=>item.id === action.payload.id ? action.payload : item)
            state.document_single = false
            state.message = true
        },
        deleteToDocument: (state,action)=>{
            state.documents = state.documents.filter(item=>item.id !== action.payload.id)
            state.message = 'deleted'
        },
        messageReset: (state,action)=>{
            state.message = false
        },
        messageFail: (state,action)=>{
            state.message = 'error'
        }
    }
})

export const getAlLDocuments = (str) => apiCall({
    url: 'track/?cat='+str,
    method: 'GET',
    onSuccess: slice.actions.getDocuments.type
})

export const getAlLThis = (data) => apiCall({
    url: "track/?getall="+data['part']+","+data['code'],
    method: 'GET',
    onSuccess: slice.actions.getDocuments.type,
    onFail: slice.actions.messageFail.type,
})

export const documentSave = (data) => apiCall({
    url: 'track/',
    method: 'POST',
    onSuccess: slice.actions.saveDocument.type,
    onFail: slice.actions.messageFail.type,
    headers: {
        "Content-Type": "multipart/form-data",
    },
    data,
})

export const getDocument = (id) => apiCall({
    url: 'track/'+id,
    method: 'GET',
    onSuccess: slice.actions.getOneDocument.type,
})

export const editSaveDocument = (data) => apiCall({
    url: 'serial-numbers/',
    method: 'POST',
    onSuccess: slice.actions.editDocument.type,
    onFail: slice.actions.messageFail.type,
    data,
})

export const deleteDocument = (data) => apiCall({
    url: 'track/'+data.id+'/',
    method: 'DELETE',
    onSuccess: slice.actions.deleteToDocument.type,
    onFail: slice.actions.messageFail.type,
})

export default slice.reducer
export const {messageReset} = slice.actions